module.exports = __webpack_public_path__ + "img/vk.e59f5a0e.svg";